import React from 'react';
import { 
    Box, 
    Flex, 
    Heading, 
    Text,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Button 
} from '@chakra-ui/react';
import { BsBoxArrowDown } from 'react-icons/bs';
import { OverviewProps } from '../../types/layout';

export default function OverviewHeader({
    username,
    overviewItemsList,
    onDownloadOptionSelect,
}: OverviewProps['header']) {
    return (
        <>
            <Flex justifyContent={'space-between'} alignItems='center'>
                <Heading as='h3' size='lg'>
                    Hi, { username }
                </Heading>
                <Menu>
                    <MenuButton height='2.1rem' as={Button} fontSize='sm' leftIcon={<BsBoxArrowDown />}>
                        Download
                    </MenuButton>
                    <MenuList>
                        {overviewItemsList.map((item: string, index: number) => (
                            <MenuItem 
                                key={index} 
                                onClick={() => onDownloadOptionSelect!(item)}
                            >
                                {item}
                            </MenuItem>
                        ))}
                    </MenuList>
                </Menu>
            </Flex>
            <Box>                
                <Text fontSize='md' color='gray.500'>Welcome back to Phoenix CRM Dashboard</Text>
            </Box>
        </>
    )
}